import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import generateConditionLabel from '../generateConditionLabel';
// eslint-disable-next-line import/no-cycle
import AnyOrAllOfConditionEditForm from './AnyOrAllOfConditionEditForm';
import Form from '../../../components/useForm';
import { useApiClient, convertAxiosErrorToUserFacingMessage } from '../../../context/ApiClientContext';
import useToast from '../../../hooks/useToast';
import basicServiceHandler from '../../../services/basicServiceHandler';

export default function SubconditionForm(props) {
  const {
    subcondition,
    onSuccess,
  } = props;
  const apiClient = useApiClient();

  const [removing, setRemoving] = useState(false);
  const { toastSetSuccessNotification, toastSetErrorNotification } = useToast();
  const handleRemove = () => {
    setRemoving(true);
    basicServiceHandler(
      () => apiClient.removeCondition(subcondition.id),
      () => { onSuccess(); toastSetSuccessNotification('Removed'); },
      (error) => { toastSetErrorNotification(`Error: ${convertAxiosErrorToUserFacingMessage(error)}`); },
      () => setRemoving(false),
    );
  };

  const RemoveButton = (
    <Grid item xs="auto" sx={{ ml: 1 }}>
      <Tooltip title="Remove">
        <span>
          <IconButton aria-label="Remove" onClick={handleRemove} disabled={removing} size="small">
            <Delete />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  );

  if (subcondition.conditionType === 'anyOf' || subcondition.conditionType === 'allOf') {
    return (
      <Grid container key={`anyAll_${subcondition.id}`} direction="row" alignItems="center">
        <Typography variant="subtitle1" sx={{ ml: 2 }}>
          {'-  '}
        </Typography>
        <Grid item xs={10} sx={{ marginLeft: 1 }}>
          <Form>
            <AnyOrAllOfConditionEditForm
              conditionId={subcondition.id}
              conditionType={subcondition.conditionType}
              subconditions={subcondition.subconditions}
              onSuccess={onSuccess}
            />
          </Form>
        </Grid>
        {RemoveButton}
      </Grid>
    );
  }

  const label = generateConditionLabel(subcondition);
  return (
    <Grid container alignItems="center">
      <Typography key={label} variant="subtitle1" sx={{ ml: 2 }}>
        {`-  ${label}`}
      </Typography>
      {RemoveButton}
    </Grid>
  );
}

SubconditionForm.propTypes = {
  subcondition: PropTypes.shape({
    id: PropTypes.number,
    conditionType: PropTypes.string,
    subconditions: PropTypes.arrayOf(PropTypes.shape({ conditionType: PropTypes.string })),
  }).isRequired,
  onSuccess: PropTypes.func.isRequired,
};
